/* eslint-disable consistent-return */
import React, { useEffect, useState } from "react";
import { Button, Row, Table, Tooltip, DatePicker, Input, Spin, Select, Col, Form } from "antd";
import "../../styles/filters-form.less";

import "./ServiceProfile.less";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  displayFormat,
  toDisplayFormat,
  toDisplayFormatWithTime,
  toHttpFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { expandedTableEyeIcon } from "../../lib/icons";
import {
  fetchServiceProfiles,
  fetchServiceProfilesVersions,
  updateProfilesVersion,
  deleteProfilesVersion,
} from "../../store/slices/service-profile";
import tickIcon from "../../img/done.svg";
import deleteIcon from "../../img/delete-round.svg";
import pencilWithPlusIcon from "../../img/pencil-plus.svg";
import edit from "../../img/edit.svg";
import pencilWithCalendarIcon from "../../img/pencil-calendar.svg";
import { checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import HistoryAndPropertyModal from "../HistoryAndPropertyModal/HistoryAndPropertyModal";
import { ReactComponent as DotsIcon } from "../../img/3dots.svg";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE } from "../../lib/const/permissions";
import { limitText } from "../../lib/utils/limitText";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";

const ServiceProfile = ({
  serviceProfiles,
  serviceProfilesLoading,
  invoicePeriodStatus,
  prePaymentPeriodStatus,
  paymentTypeStatus,
  onChangeDateProfiles,
  setFindProfilesByDate,
  queryStringServiceProfiles,
}) => {
  const { serviceProfilesVersions, serviceProfilesVersionsLoading } = useSelector(
    (state) => state.serviceProfile
  );

  const dispatch = useDispatch();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [profileVersionId, setProfileVersionId] = useState(null);
  const [dataVersion, setDataVersion] = useState("");
  const [form] = Form.useForm();
  const { Option } = Select;

  const [serviceProfileRequestBody, setServiceProfileRequestBody] = useState({
    id: 0,
    fromDate: "",
    toDate: "",
    name: "",
    profileTypeId: null,
    paymentTypeId: null,
    invoicePeriodId: null,
    prepaymentPeriodId: null,
    prepaymentToPayDays: null,
    prepaymentBeforeDays: null,
    billToPayDays: null,
    billPeriodId: null,
    dsc: "",
    tenantId: null,
  });

  const [editingKey, setEditingKey] = useState(null);
  const [formCurrencyEditStatus, setFormCurrencyEditStatus] = useState("idle");
  const isEditing = (rec) => rec.key === editingKey;
  const isEditingProfileToDate = formCurrencyEditStatus === "editingProfileToDate";
  const isEditingProfile = formCurrencyEditStatus === "editingProfile";
  const isMakingNewProfileVersion = formCurrencyEditStatus === "createNewVersion";
  const dateFormat = displayFormat;
  const dateNowParse = toHttpFormat(moment());
  const dateNow = moment();
  const [object, setObject] = useState("");

  const handleShowModal = (objId) => {
    setObject(objId);
  };

  const handleHideModal = () => {
    setObject("");
  };

  useEffect(() => {
    setDataVersion(
      serviceProfilesVersions &&
        serviceProfilesVersions?.map((item, index) => ({
          key: String(`${index}prop`),
          id: item.id,
          name: item?.name,
          paymentTypeId: item.paymentTypeId,
          invoicePeriodId: item.invoicePeriodId,
          prepaymentPeriodId: item.prepaymentPeriodId,
          prepaymentToPayDays: item.prepaymentToPayDays,
          prepaymentBeforeDays: item.prepaymentBeforeDays,
          billToPayDays: item.billToPayDays,
          currentDate: moment().isBetween(item.fromDate, item.toDate),
          pastDate: moment(item.fromDate).isBefore(dateNowParse),
          futureDate: moment(item.fromDate).isAfter(dateNowParse),
          tenantId: item.tenantId,
          fromDateForRequestBody: item.fromDate,
          toDateForRequestBody: item.toDate,
          dsc: item.dsc,
          lastVersion: String(index) === String(0) ? "lastVersion" : "",
        }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceProfilesVersions]);

  const columnsWidths = {
    id: "100px",
    name: "250px",
    paymentTypeId: "150px",
    invoicePeriodId: "150px",
    prepaymentPeriodId: "150px",
    prepaymentToPayDays: "190px",
    prepaymentBeforeDays: "190px",
    billToPayDays: "190px",
    period: "160px",
    actions: "100px",
    // eye: "48px",
    buttons: "42px",
  };

  const getColumnsInner = () => [
    {
      title: "ID профиля",
      dataIndex: "id",
      key: "id",
      width: columnsWidths.id,
      hidden: true,
    },
    {
      title: "Наименование",
      dataIndex: "name",
      key: "name",
      render: (val, record) => {
        const editable = isEditing(record);

        const onChange = (e) => {
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            name: e.target.value,
          });
        };
        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <Form.Item
            className="form-item-required__hidden-error__mb0"
            initialValue={val}
            name="name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input onChange={onChange} value={serviceProfileRequestBody.name} />
          </Form.Item>
        ) : (
          <>{val}</>
        );
      },
      width: columnsWidths.name,
    },
    {
      title: "Тип оплаты",
      dataIndex: "paymentTypeId",
      key: "paymentTypeId",
      render: (val, record) => {
        const editable = isEditing(record);

        const prepaymentName =
          paymentTypeStatus && paymentTypeStatus.find((item) => item?.id === val);

        const onChangePaymentId = (e) => {
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            paymentTypeId: e,
          });
        };

        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <>
            <Form.Item
              className="form-item-required__hidden-error__mb0"
              initialValue={val}
              name="paymentTypeId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: "100%" }} onChange={onChangePaymentId}>
                {paymentTypeStatus &&
                  paymentTypeStatus.map((item) => (
                    <Option key={item.id} value={item.id}>
                      <div title={item.name}>{limitText(item.name, 11)}</div>
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </>
        ) : (
          <>{prepaymentName?.name}</>
        );
      },
      width: columnsWidths.paymentTypeId,
    },
    {
      title: "Расчётный период",
      dataIndex: "invoicePeriodId",
      key: "invoicePeriodId",
      render: (val, record) => {
        const editable = isEditing(record);

        const invoiceName =
          invoicePeriodStatus && invoicePeriodStatus.find((item) => item?.id === val);

        const onChangePaymentId = (e) => {
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            invoicePeriodId: e,
          });
        };

        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <>
            <Form.Item
              className="form-item-required__hidden-error__mb0"
              initialValue={val}
              name="invoicePeriodId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: "100%" }} onChange={onChangePaymentId}>
                {invoicePeriodStatus &&
                  invoicePeriodStatus.map((item) => (
                    <Option key={item.id} value={item.id}>
                      <div title={item.name}>{limitText(item.name, 11)}</div>
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </>
        ) : (
          <>{invoiceName?.name}</>
        );
      },
      width: columnsWidths.invoicePeriodId,
    },
    {
      title: "Периодичность счёта",
      dataIndex: "prepaymentPeriodId",
      key: "prepaymentPeriodId",
      render: (val, record) => {
        const editable = isEditing(record);

        const prePaymentName =
          prePaymentPeriodStatus && prePaymentPeriodStatus.find((item) => item?.id === val);

        const onChange = (e) => {
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            prepaymentPeriodId: e,
          });
        };

        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <>
            <Form.Item
              className="form-item-required__hidden-error__mb0"
              initialValue={val}
              name="prepaymentPeriodId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: "100%" }} onChange={onChange}>
                {prePaymentPeriodStatus &&
                  prePaymentPeriodStatus.map((item) => (
                    <Option key={item.id} value={item.id}>
                      <div title={item.name}>{limitText(item.name, 11)}</div>
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </>
        ) : (
          <>{prePaymentName?.name}</>
        );
      },
      width: columnsWidths.prepaymentPeriodId,
    },
    {
      title: "Срок оплаты счёта на предоплату",
      dataIndex: "prepaymentToPayDays",
      key: "prepaymentToPayDays",
      render: (val, record) => {
        const editable = isEditing(record);

        const onChange = (e) => {
          const { value } = e.target;
          const reg = /^[0-9]+$/;
          if (
            // eslint-disable-next-line no-restricted-globals
            (!isNaN(value) && reg.test(value)) ||
            value === ""
          ) {
            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              prepaymentToPayDays: value,
            });
          }
          if (Number(value) === 0) {
            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              prepaymentToPayDays: value.replace(/[0]/g, 1),
            });
          }
        };

        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <Form.Item
            className="form-item-required__hidden-error__mb0"
            initialValue={val}
            name="prepaymentToPayDays"
            rules={[
              {
                required: true,
              },
              {
                pattern: /^(|[1-9][0-9]*)$/,
              },
            ]}
          >
            <Input
              onChange={onChange}
              placeholder="Введите число > 0"
              value={serviceProfileRequestBody.prepaymentToPayDays}
              maxLength={5}
            />
          </Form.Item>
        ) : (
          <>{val}</>
        );
      },
      width: columnsWidths.prepaymentToPayDays,
    },
    {
      title: "Выставлять счёт на предоплату за",
      dataIndex: "prepaymentBeforeDays",
      key: "prepaymentBeforeDays",
      render: (val, record) => {
        const editable = isEditing(record);

        const onChange = (e) => {
          const { value } = e.target;
          const reg = /^[0-9]+$/;
          if (
            // eslint-disable-next-line no-restricted-globals
            (!isNaN(value) && reg.test(value)) ||
            value === ""
          ) {
            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              prepaymentBeforeDays: value,
            });
          }
          if (Number(value) === 0) {
            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              prepaymentBeforeDays: value.replace(/[0]/g, 1),
            });
          }
        };

        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <Form.Item
            className="form-item-required__hidden-error__mb0"
            name="prepaymentBeforeDays"
            initialValue={val}
            rules={[
              {
                required: true,
              },
              {
                pattern: /^(|[1-9][0-9]*)$/,
              },
            ]}
          >
            <Input
              onChange={onChange}
              placeholder="Введите число > 0"
              value={serviceProfileRequestBody.prepaymentBeforeDays}
              maxLength={5}
            />
          </Form.Item>
        ) : (
          <>{val}</>
        );
      },
      width: columnsWidths.prepaymentBeforeDays,
    },
    {
      title: "Срок оплаты счета на постоплату",
      dataIndex: "billToPayDays",
      key: "billToPayDays",
      render: (val, record) => {
        const editable = isEditing(record);

        const onChange = (e) => {
          const { value } = e.target;
          const reg = /^[0-9]+$/;
          if (
            // eslint-disable-next-line no-restricted-globals
            (!isNaN(value) && reg.test(value)) ||
            value === ""
          ) {
            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              billToPayDays: value,
            });
          }
          if (Number(value) === 0) {
            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              billToPayDays: value.replace(/[0]/g, 1),
            });
          }
        };

        return editable && (isMakingNewProfileVersion || isEditingProfile) ? (
          <>
            <Form.Item
              className="form-item-required__hidden-error__mb0"
              name="billToPayDays"
              initialValue={val}
              rules={[
                {
                  required: true,
                },
                {
                  pattern: /^(|[1-9][0-9]*)$/,
                },
              ]}
            >
              <Input
                onChange={onChange}
                placeholder="Введите число > 0"
                value={serviceProfileRequestBody.billToPayDays}
                maxLength={5}
              />
            </Form.Item>
          </>
        ) : (
          <>{val}</>
        );
      },
      width: columnsWidths.billToPayDays,
    },
    {
      title: "Период действия",
      dataIndex: "period",
      key: "period",
      render: (val, record) => {
        const editable = isEditing(record);

        const fromDateValue = moment(
          toDisplayFormat(record.fromDateForRequestBody),
          "DD.MM.YYYY"
        ).add(1, "day");

        const toDateValue = moment(toDisplayFormat(record.toDateForRequestBody), "DD.MM.YYYY");

        const compareDates = () =>
          toDisplayFormat(record.fromDateForRequestBody) ===
          toDisplayFormat(record.toDateForRequestBody);

        const onChangeFromDate = (e) => {
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            fromDate: toHttpFormatStartOfDay(e),
          });
        };

        const onChangeToDate = (e) => {
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            toDate: toHttpFormatEndOfDay(e),
          });
        };

        if (editable && isEditingProfileToDate) {
          return (
            <>
              <Form.Item className="form-item-required__hidden-error__mb0" name="period">
                {record.fromDateForRequestBody
                  ? toDisplayFormat(record.fromDateForRequestBody)
                  : ""}{" "}
                -{" "}
                <DatePicker
                  format={dateFormat}
                  onChange={onChangeToDate}
                  defaultValue={toDateValue}
                  disabledDate={(current) => current < fromDateValue}
                  style={{ width: "115px" }}
                  allowClear={false}
                />
              </Form.Item>
            </>
          );
        }

        const disabledDates = (cur) => {
          if (moment(record.fromDateForRequestBody).isBefore(moment().startOf("month"))) {
            return cur.isBefore(moment().startOf("month"));
          }

          if (compareDates()) {
            return cur;
          }

          return cur.isBefore(fromDateValue) || cur.isAfter(toDateValue);
        };

        const defaultValues = () => {
          if (moment(record.fromDateForRequestBody).isBefore(moment().startOf("month"))) {
            return moment().startOf("month");
          }

          if (compareDates()) {
            return "";
          }

          return fromDateValue;
        };

        return editable && isMakingNewProfileVersion ? (
          <>
            <Form.Item className="form-item-required__hidden-error__mb0" name="period">
              <DatePicker
                format={dateFormat}
                onChange={onChangeFromDate}
                defaultValue={defaultValues}
                disabledDate={disabledDates}
                style={{ width: "115px" }}
                allowClear={false}
              />
            </Form.Item>
            - {record.toDateForRequestBody ? toDisplayFormat(record.toDateForRequestBody) : ""}
          </>
        ) : (
          <>
            {" "}
            {record.fromDateForRequestBody
              ? toDisplayFormat(record.fromDateForRequestBody)
              : ""} -{" "}
            {record.toDateForRequestBody ? toDisplayFormat(record.toDateForRequestBody) : ""}
          </>
        );
      },
      width: columnsWidths.period,
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      // eslint-disable-next-line no-unused-vars,consistent-return
      render: (val, record, index) => {
        const editable = isEditing(record);
        const disabled = isMakingNewProfileVersion || isEditingProfileToDate || isEditingProfile;

        const nameValue = val.name;
        const paymentTypeIdValue = val.paymentTypeId;
        const invoicePeriodIdValue = val.invoicePeriodId;
        const prepaymentPeriodValue = val.prepaymentPeriodId;
        const prepaymentToPayDaysValue = val.prepaymentToPayDays;
        const prepaymentBeforeDaysValue = val.prepaymentBeforeDays;
        const billToPayDaysValue = val.billToPayDays;
        const fromDateValue = val.fromDateForRequestBody;

        const handleEdit = (currencyEditStatus) => () => {
          form.resetFields();
          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            name: nameValue,
            paymentTypeId: paymentTypeIdValue,
            invoicePeriodId: invoicePeriodIdValue,
            prepaymentPeriodId: prepaymentPeriodValue,
            prepaymentToPayDays: prepaymentToPayDaysValue,
            prepaymentBeforeDays: prepaymentBeforeDaysValue,
            billToPayDays: billToPayDaysValue,
            fromDate: fromDateValue,
            toDate: toHttpFormatEndOfDay(record.toDateForRequestBody),
          });

          setEditingKey(() => record.key);
          setFormCurrencyEditStatus(currencyEditStatus);
        };

        const addNewVersion = (currencyEditStatus) => () => {
          form.resetFields();
          const fromDateParse = () => {
            if (moment(record.fromDateForRequestBody).isBefore(moment().startOf("month"))) {
              return toHttpFormatStartOfDay(moment().startOf("month"));
            }
            return toHttpFormatStartOfDay(
              moment(
                toDisplayFormatWithTime(record.fromDateForRequestBody),
                "DD.MM.YYYY HH:mm:ss"
              ).add(1, "day")
            );
          };

          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            name: nameValue,
            paymentTypeId: paymentTypeIdValue,
            invoicePeriodId: invoicePeriodIdValue,
            prepaymentPeriodId: prepaymentPeriodValue,
            prepaymentToPayDays: prepaymentToPayDaysValue,
            prepaymentBeforeDays: prepaymentBeforeDaysValue,
            billToPayDays: billToPayDaysValue,
            fromDate:
              toDisplayFormat(record.fromDateForRequestBody) ===
              toDisplayFormat(record.toDateForRequestBody)
                ? null
                : fromDateParse(),
          });

          setEditingKey(() => `new${record.key}`);
          setFormCurrencyEditStatus(currencyEditStatus);

          const newRecord = {
            ...dataVersion[index],
            key: `new${dataVersion[index].key}`,
          };

          setDataVersion((prev) => [...prev.slice(0, index), newRecord, ...prev.slice(index)]);
        };

        const handleCancel = () => {
          setEditingKey(null);
          form.resetFields();
          if (isMakingNewProfileVersion)
            setDataVersion((prev) => [...prev.slice(0, index), ...prev.slice(index + 1)]);

          setFormCurrencyEditStatus("idle");

          setServiceProfileRequestBody({
            ...serviceProfileRequestBody,
            name: "",
            paymentTypeId: null,
            invoicePeriodId: null,
            prepaymentPeriodId: null,
            prepaymentToPayDays: null,
            prepaymentBeforeDays: null,
            billToPayDays: null,
            fromDate: null,
          });
        };

        const handleSubmit = () => {
          form.validateFields().then(async () => {
            const dataCreate = {
              ...serviceProfileRequestBody,
              id: record.id,
              fromDate: isMakingNewProfileVersion
                ? serviceProfileRequestBody.fromDate
                : record.fromDateForRequestBody,
              toDate: record.toDateForRequestBody,
              name: serviceProfileRequestBody.name,
              profileTypeId: 1,
              paymentTypeId: serviceProfileRequestBody.paymentTypeId,
              invoicePeriodId: serviceProfileRequestBody.invoicePeriodId,
              prepaymentPeriodId: serviceProfileRequestBody.prepaymentPeriodId,
              prepaymentToPayDays: serviceProfileRequestBody.prepaymentToPayDays,
              prepaymentBeforeDays: serviceProfileRequestBody.prepaymentBeforeDays,
              billToPayDays: serviceProfileRequestBody.billToPayDays,
              billPeriodId: serviceProfileRequestBody.invoicePeriodId,
              dsc: record.dsc,
              tenantId: record.tenantId,
            };

            if (isEditingProfileToDate)
              await dispatch(
                deleteProfilesVersion({
                  id: record.id,
                  fromDate: serviceProfileRequestBody.toDate,
                })
              );
            if (isMakingNewProfileVersion)
              await dispatch(
                updateProfilesVersion({
                  id: record.id,
                  fromDate: serviceProfileRequestBody.fromDate,
                  force: false,
                  values: dataCreate,
                })
              );
            if (isEditingProfile)
              await dispatch(
                updateProfilesVersion({
                  id: record.id,
                  fromDate: record.fromDateForRequestBody,
                  force: true,
                  values: dataCreate,
                })
              );

            await dispatch(fetchServiceProfiles({ queryString: queryStringServiceProfiles }));
            await dispatch(
              fetchServiceProfilesVersions({
                id: profileVersionId,
              })
            );

            setEditingKey(null);
            setFormCurrencyEditStatus("idle");
            form.resetFields();

            setServiceProfileRequestBody({
              ...serviceProfileRequestBody,
              name: "",
              paymentTypeId: null,
              invoicePeriodId: null,
              prepaymentPeriodId: null,
              prepaymentToPayDays: null,
              prepaymentBeforeDays: null,
              billToPayDays: null,
              fromDate: null,
            });
          });
        };

        return (
          <>
            {editable && hasAccess(MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE) && (
              <Form.Item className="form-item-required__hidden-error__mb0">
                <div style={{ display: "flex", flexWrap: "noWrap" }}>
                  <Tooltip title="Подтвердить">
                    <Button
                      icon={<img src={tickIcon} alt="tick" width="16px" />}
                      className="icon"
                      type="text"
                      htmlType="submit"
                      onClick={handleSubmit}
                    />
                  </Tooltip>
                  <Tooltip title="Отменить">
                    <Button
                      icon={<img src={deleteIcon} width="16px" alt="delete" />}
                      type="text"
                      className="icon"
                      htmlType="button"
                      onClick={handleCancel}
                    />
                  </Tooltip>
                </div>
              </Form.Item>
            )}
            {!editable && hasAccess(MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE) && (
              <Form.Item className="form-item-required__hidden-error__mb0">
                <div style={{ display: "flex", flexWrap: "noWrap" }}>
                  <Tooltip title="Добавить версию">
                    {(record.futureDate || record.currentDate) && (
                      <Button
                        icon={<img src={pencilWithPlusIcon} alt="pencil with plus" width="16px" />}
                        type="text"
                        htmlType="button"
                        onClick={addNewVersion("createNewVersion")}
                        disabled={disabled}
                      />
                    )}
                  </Tooltip>
                  <Tooltip title="Редактировать версию">
                    {(record.futureDate || record.currentDate) &&
                      moment(record.fromDateForRequestBody).isAfter(
                        moment().subtract(1, "months").endOf("month")
                      ) && (
                        <Button
                          icon={<img src={edit} alt="pencil" width="16px" />}
                          type="text"
                          htmlType="button"
                          disabled={disabled}
                          onClick={handleEdit("editingProfile")}
                        />
                      )}
                  </Tooltip>
                  <Tooltip title="Изменить дату закрытия">
                    {record.lastVersion && (
                      <Button
                        icon={
                          <img
                            src={pencilWithCalendarIcon}
                            alt="pencil with calendar"
                            width="18px"
                          />
                        }
                        type="text"
                        htmlType="button"
                        disabled={disabled}
                        onClick={handleEdit("editingProfileToDate")}
                      />
                    )}
                  </Tooltip>
                </div>
              </Form.Item>
            )}
          </>
        );
      },
      width: columnsWidths.actions,
    },
    {
      key: "eye",
      width: columnsWidths.eye,
    },
    {
      dataIndex: "",
      key: "button",
      render: (record) => (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleShowModal(record);
          }}
          className="button-icon iconButton"
          style={{ outline: "none" }}
          icon={<DotsIcon />}
        />
      ),
      width: columnsWidths.buttons,
    },
  ];

  const [columnsInner, setColumnsInner] = useState(getColumnsInner());

  // Обновление колонок (для отображения фильтров в заголовках) с сохранением состояния hidden
  useEffect(() => {
    setColumnsInner((prev) => {
      const newColumnsInner = getColumnsInner();
      const getNewColumn = ({ key }) => newColumnsInner.find((item) => item.key === key);
      return prev.map((prevColumn) => {
        const newColumn = getNewColumn(prevColumn);
        if (newColumn) {
          return { ...prevColumn, title: newColumn.title, render: newColumn.render };
        }
        return prevColumn;
      });
    });
  }, [
    dataVersion,
    serviceProfileRequestBody,
    paymentTypeStatus,
    invoicePeriodStatus,
    prePaymentPeriodStatus,
  ]);

  const buildRowClassName = (record) => {
    const editable = isEditing(record);
    const editNew = record.key.includes("new");
    const activeClassName = "currency-version-row";

    if (record.currentDate && !editable) return `${activeClassName} current-date`;
    if (record.currentDate && editable && !editNew)
      return `${activeClassName} current-date active-row`;
    if (record.currentDate && editable && editNew)
      return `${activeClassName} current-date active-row new-prop`;
    if (record.pastDate && !editable) return `${activeClassName} past-date`;
    if (record.pastDate && editable) return `${activeClassName} past-date active-row`;
    if (record.futureDate && !editable) return `${activeClassName} future-date`;
    if (record.futureDate && editable) return `${activeClassName} future-date active-row`;
  };

  const innerTable = () => {
    if (!checkIsLoading(serviceProfilesVersionsLoading)) {
      return (
        <div className="version-inner-table">
          <Form form={form}>
            <Table
              className="inner-table"
              size="small"
              columns={columnsInner.filter(({ hidden }) => !hidden)}
              dataSource={dataVersion}
              pagination={false}
              showHeader={false}
              rowClassName={buildRowClassName}
              loading={checkIsLoading(serviceProfilesVersionsLoading)}
            />
          </Form>
        </div>
      );
    }
    return <Spin className="spin" />;
  };

  const tableData =
    serviceProfiles &&
    serviceProfiles?.map((item) => ({
      ...item,
      key: item.id,
      period: item,
    }));

  const getColumns = () => [
    {
      title: "ID профиля",
      dataIndex: "id",
      key: "id",
      width: columnsWidths.id,
      hidden: true,
    },
    {
      title: "Наименование",
      dataIndex: "name",
      key: "name",
      width: columnsWidths.name,
    },
    {
      title: "Тип оплаты",
      dataIndex: "paymentTypeId",
      key: "paymentTypeId",
      width: columnsWidths.paymentTypeId,
      render: (paymentTypeId) =>
        paymentTypeStatus.find((item) => item?.id === paymentTypeId)?.name || "",
    },
    {
      title: "Расчётный период",
      dataIndex: "invoicePeriodId",
      key: "invoicePeriodId",
      width: columnsWidths.invoicePeriodId,
      render: (invoicePeriodId) =>
        invoicePeriodStatus.find((item) => item?.id === invoicePeriodId)?.name || "",
    },
    {
      title: "Периодичность счёта",
      dataIndex: "prepaymentPeriodId",
      key: "prepaymentPeriodId",
      width: columnsWidths.prepaymentPeriodId,
      render: (prepaymentPeriodId) =>
        prePaymentPeriodStatus.find((item) => item?.id === prepaymentPeriodId)?.name || "",
    },
    {
      title: "Срок оплаты счёта на предоплату",
      dataIndex: "prepaymentToPayDays",
      key: "prepaymentToPayDays",
      width: columnsWidths.prepaymentToPayDays,
    },
    {
      title: "Выставлять счёт на предоплату за",
      dataIndex: "prepaymentBeforeDays",
      key: "prepaymentBeforeDays",
      width: columnsWidths.prepaymentBeforeDays,
    },
    {
      title: "Срок оплаты счета на постоплату",
      dataIndex: "billToPayDays",
      key: "billToPayDays",
      width: columnsWidths.billToPayDays,
    },
    {
      title: "Период действия",
      dataIndex: "period",
      key: "period",
      render: (record) =>
        `${record.fromDate ? toDisplayFormat(record.fromDate) : ""} - ${
          record.toDate ? toDisplayFormat(record.toDate) : ""
        }`,
      width: columnsWidths.period,
    },
    {
      key: "actions",
      width: columnsWidths.actions,
    },
    {
      dataIndex: "",
      key: "x",
      render: (record) => (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleShowModal(record);
          }}
          className="button-icon iconButton"
          style={{ outline: "none" }}
          icon={<DotsIcon />}
        />
      ),
      width: columnsWidths.buttons,
    },
  ];

  const [columns, setColumns] = useState(getColumns());

  useEffect(() => {
    setColumns(getColumns());
  }, [paymentTypeStatus, invoicePeriodStatus, prePaymentPeriodStatus]);

  return (
    <>
      <div className="container_flex">
        <div className="inner-row" style={{ marginBottom: "15px" }}>
          <Row justify="space-between" align="middle">
            <h1>Профиль оплаты</h1>
          </Row>
          <Row align="middle" justify="space-between">
            <Col span={10}>
              <label style={{ marginRight: "10px" }}>Дата:</label>
              <DatePicker
                allowClear={false}
                defaultValue={dateNow}
                onChange={onChangeDateProfiles}
                // style={{ width: "100%" }}
                format={dateFormat}
              />
              <Button
                onClick={() => setFindProfilesByDate((prev) => !prev)}
                type="primary"
                style={{ marginLeft: "15px" }}
              >
                Применить
              </Button>
            </Col>
            {hasAccess(MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE) && (
              <Col align="right">
                <Link to="/service-profile/create">
                  <Button type="primary">Добавить новый профиль</Button>
                </Link>
              </Col>
            )}
          </Row>
        </div>
        <Row justify="end" style={{ marginTop: "10px" }}>
          <ToggleColumns
            tableName="common-profiles-table"
            columns={columns}
            setColumns={setColumns}
            setChildTableColumns={setColumnsInner}
          />
        </Row>
        <>
          <Table
            className="version-table"
            size="small"
            columns={columns.filter(({ hidden }) => !hidden)}
            dataSource={tableData}
            pagination={false}
            loading={checkIsLoading(serviceProfilesLoading)}
            rowClassName={(record) =>
              record.isActive === false ? "dictionary__disabled-date" : "dictionary__enabled-date"
            }
            expandIconColumnIndex={columns.length - 1}
            expandedRowKeys={expandedRowKeys}
            expandedRowRender={() => <>{innerTable()}</>}
            expandIcon={({ expanded, record }) => {
              const handleClick = (e) => {
                form.resetFields();
                setDataVersion("");
                e.stopPropagation();
                if (!expanded) {
                  setExpandedRowKeys([record.key]);
                  setProfileVersionId(record.id);
                  setFormCurrencyEditStatus("idle");
                  setEditingKey(null);
                  dispatch(
                    fetchServiceProfilesVersions({
                      id: record.id,
                    })
                  );
                } else {
                  setExpandedRowKeys([]);
                }
              };
              return (
                <div className="version-table__eye-wrapper">
                  <Button
                    icon={expandedTableEyeIcon(expanded ? "#0E5298" : "#86ACD2")}
                    onClick={handleClick}
                    type="text"
                    htmlType="button"
                    className="iconButton"
                  />
                </div>
              );
            }}
            scroll={{ x: true }}
          />
        </>
        <HistoryAndPropertyModal
          objectTypeSysname="service_billing_profile"
          objectId={object?.id}
          handleHideModal={handleHideModal}
          visibleModal={object?.id}
          hasAccessToEdit={hasAccess(MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE)}
          dateObjectFromForCalendar={object?.period?.fromDate}
          dateObjectToForCalendar={object?.period?.toDate}
        />
      </div>
    </>
  );
};

export default ServiceProfile;
